import { EInvoiceType, DocumentType, DocumentDirection } from '~/types/document';
import { DocumentBuilderForm } from '~/types/document-builder';
import { DocumentUpdateRequest } from '~/types/invoicing';
import { isSelfInvoiceTD26 } from '~/utils/document';

/**
 * Applies business rules to adjust document properties before upserting.
 *
 * This function inspects the provided document values and, based on specific business rules,
 * modifies certain fields to ensure the document is upserted with the correct type and direction.
 *
 * @param {Partial<DocumentBuilderForm>} params.documentValues - The document values to evaluate and adjust.
 * @returns {Partial<DocumentUpdateRequest>} An object containing the adjusted document fields, or an empty object if no adjustments are needed.
 */
export const adjustDocumentToUpsertByRules = ({
  documentValues,
}: {
  documentValues: Partial<DocumentBuilderForm>;
}): Partial<DocumentUpdateRequest> => {
  switch (true) {
    case isSelfInvoiceTD26(documentValues.type, documentValues.subtype):
      return { documentType: DocumentType.SelfInvoice };
    // Self invoice TD01
    case documentValues.type === DocumentType.SelfInvoice && documentValues.subtype === EInvoiceType.Fattura:
      return { documentType: DocumentType.Invoice, direction: DocumentDirection.received };
    default:
      return {};
  }
};
